export const URL_BASE = 'api/v1/admin/'